import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    imports: [RouterOutlet]
})
export class AdminComponent implements OnInit {

  constructor(public translate: TranslateService) {
    translate.addLangs(['en', 'fr']);
    // translate.setDefaultLang('en');
   }

  ngOnInit() {
    console.log('admin');
  }

}
